import { motion } from 'framer-motion';
import Avatar from './Avatar';

export default function ProfilePopup({ user, onClose }) {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      onClick={onClose}
    >
      <motion.div 
        className={`p-6 rounded-xl w-full max-w-sm mx-4 ${user.darkMode ? 'bg-slate-800' : 'bg-white'}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex flex-col items-center">
          <Avatar 
            firstName={user.first_name} 
            lastName={user.last_name} 
            className="w-20 h-20 text-2xl mb-4"
          />
          <h3 className="text-xl font-bold">{user.first_name} {user.last_name}</h3>
          <p className={`${user.darkMode ? 'text-gray-400' : 'text-gray-600'} mb-4`}>{user.email}</p>
          
          <div className="w-full border-t pt-4">
            <button className="w-full py-2 rounded-lg bg-gradient-to-r from-blue-500 to-purple-600 text-white">
              View Profile
            </button>
            <button 
              className={`w-full py-2 mt-2 rounded-lg ${user.darkMode ? 'bg-slate-700' : 'bg-gray-200'}`}
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};